import React from "react";
import {
  AttachMoney,
  Label,
  AccountBalance,
  Assessment,
  Business,
  FileDownload,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Folder,
  Lock,
  Warning,
  Check,
  Search,
  Add,
  Save,
  Receipt,
  Checklist,
  TableChart,
  Repeat,
  Layers,
  CalendarMonth,
} from "@mui/icons-material";

const iconSize = { fontSize: 20 };
const iconSizeSmall = { fontSize: 18 };
const iconSizeLarge = { fontSize: 28 };

/** MUI icons for use across the app. Use wrapper for consistent size. */
export const Icons = {
  Transactions: (props?: { className?: string; sx?: object }) => (
    <AttachMoney sx={iconSize} {...props} />
  ),
  Categories: (props?: { className?: string; sx?: object }) => (
    <Label sx={iconSize} {...props} />
  ),
  BankAccount: (props?: { className?: string; sx?: object }) => (
    <AccountBalance sx={iconSize} {...props} />
  ),
  CostCenter: (props?: { className?: string; sx?: object }) => (
    <Assessment sx={iconSize} {...props} />
  ),
  Company: (props?: { className?: string; sx?: object }) => (
    <Business sx={iconSize} {...props} />
  ),
  Import: (props?: { className?: string; sx?: object }) => (
    <FileDownload sx={iconSize} {...props} />
  ),
  Edit: (props?: { className?: string; sx?: object }) => (
    <EditIcon sx={iconSizeSmall} {...props} />
  ),
  Delete: (props?: { className?: string; sx?: object }) => (
    <DeleteIcon sx={iconSizeSmall} {...props} />
  ),
  Folder: (props?: { className?: string; sx?: object }) => (
    <Folder sx={iconSize} {...props} />
  ),
  Lock: (props?: { className?: string; sx?: object }) => (
    <Lock sx={iconSize} {...props} />
  ),
  Warning: (props?: { className?: string; sx?: object }) => (
    <Warning sx={iconSize} {...props} />
  ),
  Check: (props?: { className?: string; sx?: object }) => (
    <Check sx={iconSize} {...props} />
  ),
  Search: (props?: { className?: string; sx?: object }) => (
    <Search sx={iconSizeSmall} {...props} />
  ),
  Add: (props?: { className?: string; sx?: object }) => (
    <Add sx={iconSizeSmall} {...props} />
  ),
  Save: (props?: { className?: string; sx?: object }) => (
    <Save sx={iconSize} {...props} />
  ),
  Receipt: (props?: { className?: string; sx?: object }) => (
    <Receipt sx={iconSize} {...props} />
  ),
  Checklist: (props?: { className?: string; sx?: object }) => (
    <span className={`inline-flex items-center justify-center rounded-lg bg-[#2D3748] p-1 ${props?.className ?? ""}`.trim()}>
      <Checklist sx={{ ...iconSize, color: "#63B3ED" }} {...props} />
    </span>
  ),
  Dashboard: (props?: { className?: string; sx?: object }) => (
    <TableChart sx={iconSize} {...props} />
  ),
  Recurrency: (props?: { className?: string; sx?: object }) => (
    <Repeat sx={iconSizeSmall} {...props} />
  ),
  /** Parcelamento (várias parcelas do mesmo lançamento). */
  Installment: (props?: { className?: string; sx?: object }) => (
    <Layers sx={iconSizeSmall} {...props} />
  ),
  Calendar: (props?: { className?: string; sx?: object }) => (
    <CalendarMonth sx={iconSize} {...props} />
  ),
};

/** For page headers / modals - larger icon */
export const IconsLarge = {
  Transactions: () => <AttachMoney sx={iconSizeLarge} />,
  Categories: () => <Label sx={iconSizeLarge} />,
  BankAccount: () => <AccountBalance sx={iconSizeLarge} />,
  CostCenter: () => <Assessment sx={iconSizeLarge} />,
  Company: () => <Business sx={iconSizeLarge} />,
  Import: () => <FileDownload sx={iconSizeLarge} />,
  Folder: () => <Folder sx={iconSizeLarge} />,
  Receipt: () => <Receipt sx={iconSizeLarge} />,
  Checklist: () => (
    <span className="inline-flex items-center justify-center rounded-xl bg-[#2D3748] p-2">
      <Checklist sx={{ ...iconSizeLarge, color: "#63B3ED" }} />
    </span>
  ),
  Dashboard: () => <TableChart sx={iconSizeLarge} />,
  Recurrency: () => <Repeat sx={iconSizeLarge} />,
  Installment: () => <Layers sx={iconSizeLarge} />,
  Calendar: () => <CalendarMonth sx={iconSizeLarge} />,
};
